<template>
    <div>
        <h2>What is the most&nbsp;<strong>important</strong> for you when you buy a new car?</h2>
        <div class="box-wrapper">
            <label v-for="(item, index) in items" v-bind:for="index" class="box feature-box"
                   :class="{'is-active': mainFeatures.indexOf(item) > -1 }"
            >
                <input
                    :value="item"
                    v-bind:id="index"
                    type="checkbox"
                    v-model="mainFeatures"
                    @change='updateValue'
                    :disabled="mainFeatures.length > 2 && mainFeatures.indexOf(item) === -1"

                >
                <div class="box-content" v-html="item.title">
                </div>
                <img :src="getImagePath(item.icon)" alt="" class="img-icon">
                <div class="perspective"></div>
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'features',
        props: ['value', 'bus'],
        data() {
            return {
                items: [
                    {
                        id: 'best_price',
                        title: '<strong>Best Price</strong>',
                        icon: 'best_price',
                        type: 'economists',
                    },
                    {
                        id: 'aquistition',
                        title: 'Lower <strong>Aquisition Costs</strong>',
                        icon: 'aquistition',
                        type: 'economists',
                    },
                    {
                        id: 'operating_cost',
                        title: 'Lower Expected <strong>Operating Costs</strong>',
                        icon: 'operatin_cost',
                        type: 'economists',
                    },
                    {
                        id: 'safety',
                        title: '<strong>Premium Safety Features</strong> of the Car',
                        icon: 'safety',
                        type: 'guardians',
                    },
                    {
                        id: 'exterior',
                        title: 'Elegant <strong>Exterior Design</strong>',
                        icon: 'interior',
                        type: 'stylists',
                    },
                    {
                        id: 'interior',
                        title: 'Elegant <strong>Interior Design</strong>',
                        icon: 'exterior',
                        type: 'stylists',
                    },
                    {
                        id: 'spacious',
                        title: 'Larger <strong>Car Space</strong> (Trunk Boot Space)',
                        icon: 'spacious',
                        type: 'practitioners',
                    },
                    {
                        id: 'luxury',
                        title: 'Luxury Comfort / <strong>Comfort in The Car</strong>',
                        icon: 'luxury',
                        type: 'experts',
                    },
                    {
                        id: 'engine',
                        title: 'Stronger <strong>Engine Power</strong>',
                        icon: 'engine',
                        type: 'racers',
                    },
                    {
                        id: 'driving-characteristic',
                        title: '<strong>Above-Standard Driving Characteristics</strong> of The Car',
                        icon: 'wheel',
                        type: 'experts',
                    },
                    {
                        id: 'new_tech',
                        title: 'Better Equipment <strong>With The Latest Technology</strong>',
                        icon: 'new_tech',
                        type: 'experts',
                    },
                ],
                mainFeatures: this.value,
            };
        },

        methods: {
            updateValue() {
                this.$emit('input', this.mainFeatures);
            },
            getImagePath(name) {
                return require(`./../assets/icons/${name}-green.png`);
            },

            reset() {
                this.mainFeatures = [];
            },
        },
        mounted() {
            this.bus.$on('resetFeatures', this.reset);
        },
    };
</script>
